import { render, staticRenderFns } from "./remindTrainModal.vue?vue&type=template&id=518c0cd6&scoped=true&"
import script from "./remindTrainModal.vue?vue&type=script&lang=js&"
export * from "./remindTrainModal.vue?vue&type=script&lang=js&"
import style0 from "./remindTrainModal.vue?vue&type=style&index=0&id=518c0cd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518c0cd6",
  null
  
)

export default component.exports